import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function getModels(brand, queryParamString){
    const queryString = queryParamString || ''
    let results = ''
    try {
        results = await axios.get(`${DATAMASTER_ENDPOINT}/brands/${brand}/models${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}